<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">
                    {{ this.parentObject.pageTitle 
                    }}<span class="page_title_value">
                    {{ this.parentObject.pageTitleValue }}
                    </span>
                    </h2>
                </v-row>

                <v-col class="mt-n4 mb-2"> 
                    <v-row> 
                        <v-btn
                        v-model="goBtn"
                        @click="backButton()"
                        color="orange"
                        class="white--text"
                        >{{$t('button.back')}}</v-btn>
                    </v-row>
                </v-col>
                
                <v-container
                    id="scroll-target"
                    class="custom-form overflow-y-auto px-5"
                >

                <v-row>
                    <v-toolbar flat >
                        <v-toolbar-title>
                            {{$t('nonbankpaymentlistingreport.bankpaymentlistingforpaymentmode')}} <span class="blue--text"> {{this.data.formData.paymode}} </span> 
                                <div v-if="this.showDate" class="title-1 ">
                                    {{$t('nonbankpaymentlistingreport.payoutyear')}}
                                    <span class="blue--text"> 
                                        {{this.data.formData.pyyear}}</span>, 
                                           {{$t('statutoryexportcommonused.payoutmonth')}} 
                                            <span class="blue--text"> 
                                                {{this.data.formData.pymonth}}</span>
                                </div>
                            <div v-if="this.showID" class="title-1 "> 
                                {{$t('statutoryexportcommonused.payoutid')}} <span class="blue--text"> 
                                    {{this.data.formData.payoutcode}}</span>
                                </div>   
                                </v-toolbar-title>

                                <v-spacer></v-spacer>

                                <div class="export-icon-btns">
                            <button type="button" class="export-icon-btn export-icon-pdf" @click="printPDF" title="Export PDF">
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 13h2a2 2 0 0 1 0 4H9v-4z"/><path d="M15 13h1a2 2 0 0 1 0 4h-1"/><line x1="15" y1="17" x2="17" y2="17"/></svg>
                              PDF
                            </button>
                            <button type="button" class="export-icon-btn export-icon-csv" @click="getCSV" title="Export CSV">
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>
                              CSV
                            </button>
                          </div>
                            </v-toolbar>
                </v-row>
                <v-row>
                            
                    <v-col >
                        <div class="rpt-table-wrap">
                        <v-data-table
                            hide-default-footer
                            :headers="dataHeader"
                            :items="dataItems"
                            :items-per-page="1000"
                            multi-sort
                            :no-data-text="this.$t('vdatatable.norecordsfound')"
                        ></v-data-table>
                        </div>

                        <div class="total-bar">
                          <div class="total-bar-inner">
                            <span class="total-label">{{ $t('bankpaymentlistingreport.total') }}</span>
                            <span class="total-amount">{{ total }}</span>
                          </div>
                        </div>
                    </v-col>
                </v-row>
                </v-container>
            </v-form>
        </v-container>
    </div>
</template>

<script>

// import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
    props: {
        parentObject: Object
    },

    data() {
        return {
            publicPath: process.env.BASE_URL,
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                }
            },

            data: {
            
            formData: {
                
                 pyyear: this.$route.params.formData.pyyear,
                 pymonth: this.$route.params.formData.pymonth,
                 payoutcode: this.$route.params.formData.payoutcode,
                 paymode: this.$route.params.formData.paymode
            },

             parameters: {
                     brchid: this.$route.params.param.branchid,
                     deptid: this.$route.params.param.departmentid,
                     compnyid: this.$route.params.param.companyid,
                     emptypeid: this.$route.params.param.employmenttypeid,
                     gradeid: this.$route.params.param.gradeid,
                     staffid: this.$route.params.param.staffid,
                 },
            },

            dataHeader: [
                {text: this.$t('columns.no'),                    width: '7%',  value: 'id'},
                {text: this.$t('columns.name'),                  width: '15%', value: 'psnname'},
                {text: this.$t('columns.staffid'),              width: '9%', value: 'staffcode'},
                {text: this.$t('bankpaymentlistingreport.icnoorpassportno'),   width: '16%', value: 'idno'},
                {text: this.$t('columns.company'),               width: '15%', value: 'compnyname'},
                {text: this.$t('columns.department'),            width: '15%', value: 'deptname'},
                {text: this.$t('columns.currency'),              width: '15%', value: 'crcydesc'},
                {text: this.$t('setuppersonpayrolldirectassignment.amount'),                width: '18%', value: 'netpay'},

            ],

             tableOpt: {
                itemsPerPage: -1
            },

            showID: false,
            showDate: false,
            showTotal: false,
            total: null,
            netpay: null,


            dataItems: [],

            yearList: [],
            monthList: [],
            codeList: [],

            goBtn: false,

           
        }
    },

    methods: {


        backButton(){
            this.$router.push({name: 'parameternonbank'});
        },

        loadStaff(){

            this.goBtn = true;
            
            const vm = this;
                this.$store.dispatch('post', {url: `/nonbankpayment/${this.$store.getters.userId}`,
                payload: this.data})
                 .then(function (res){
                     vm.dataItems = res.data.rec;
                     let getamount = [];

                 for (let i = 0; i < vm.dataItems.length; i++) {
                         vm.dataItems[i].id = i + 1;
                         console.log('data', vm.dataItems)
                        
                        getamount.push(parseFloat(vm.dataItems[i].netpay.replace(/,/g, ""))
                        );
                    }
                        let gettotal = getamount.reduce(function (a, b) {
                        return a + b;
                        }, 0);

                        gettotal = gettotal.toFixed(2);

                        vm.total = gettotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                         vm.showTotal = true;
                     })
             .catch(function (err) {
                vm.errMsg = err;
                });
        },      

        printPDF() {

            const doc = new jsPDF({
                orientation: "landscape"
            })

            var head = [
                { title: this.$t('columns.no'),                      dataKey: 'id' },
                { title: this.$t('columns.name'),                    dataKey: 'psnname' },
                { title: this.$t('columns.staffid'),                dataKey: 'staffcode' },
                { title: this.$t('bankpaymentlistingreport.icnoorpassportno'),     dataKey: 'idno' },
                { title: this.$t('columns.company'),                 dataKey: 'compnyname' },
                { title: this.$t('columns.department'),              dataKey: 'deptname' },
                { title: this.$t('columns.currency'),                dataKey: 'crcydesc' },
                { title: this.$t('setuppersonpayrolldirectassignment.amount'),                  dataKey: 'netpay' },
                { title: this.$t('bankpaymentlistingreport.total'),                   dataKey: 'total'},
            ];

            let body = [];

            for (var i = 0; i < this.dataItems.length; i++) {

                body.push({
                    id : this.dataItems[i].id,
                    psnname : this.dataItems[i].psnname,
                    staffcode : this.dataItems[i].staffcode,
                    idno : this.dataItems[i].idno,
                    compnyname : this.dataItems[i].compnyname,
                    deptname : this.dataItems[i].deptname,
                    crcydesc : this.dataItems[i].crcydesc,
                    netpay : this.dataItems[i].netpay
                });

            }
                body.push({
                total: this.total,
            });
            
            doc.text(this.$t('nonbankpaymentlistingreport.nonbnkpymtlist'), 10, 10)
            doc.text(this.formData.paymode.toString(), 86, 10)
            
            if(this.formData.payoutcode){
                doc.text(this.$t('statutoryexportcommonused.payoutid'), 112, 10)
                doc.text(this.formData.payoutcode.toString(), 138, 10)
            } else {

                doc.text(this.$t('statutoryexportcommonused.payoutyear'), 112, 10)
                doc.text(this.formData.pyyear.toString(), 145 , 10) 
                doc.text(this.$t('statutoryexportcommonused.payoutmonth'), 159, 10)
                doc.text(this.formData.pymonth.toString(), 195, 10)
            }

            doc.autoTable(head, body)
            doc.save(this.$t('nonbankpaymentlistingreport.nonbankpaymentlisting') + "-" + this.data.formData.payoutcode + ".pdf");
        },

        objectToCSV(data) {
            const csvRows = [];

            // get header
            const headers = Object.keys(data[0])
            csvRows.push(headers.join(','))

            // loop over the rows
            for (const row of data) {
                const values = headers.map(header => {
                    const escaped = ('' + row[header]).replace(/"/g, '\\"')
                    return `"${escaped}"`
                })
                csvRows.push(values.join(','))
            }
            return csvRows.join('\n')
        },

        download(data) {
            const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: 'text/csv'})
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')

            a.setAttribute('hidden', '')
            a.setAttribute('href', url)
            a.setAttribute('download',this.$t('nonbankpaymentlistingreport.nonbankpaymentlisting') + "-" + this.data.formData.payoutcode + '.csv')

            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        },

        async getCSV() {
            let item = this.dataItems;
            let data = [];

            for (var i = 0; i < item.length; i++) {

                data.push({
                    [`${this.$t('columns.no')}`]: item[i].id,
                    [`${this.$t('columns.name')}`]: item[i].psnname,
                    [`${this.$t('columns.staffid')}`]: item[i].staffcode,
                    [`${this.$t('bankpaymentlistingreport.icnoorpassportno')}`]: item[i].idno,
                    [`${this.$t('columns.company')}`]: item[i].compnyname,
                    [`${this.$t('columns.department')}`]: item[i].deptname,
                    [`${this.$t('columns.currency')}`]: item[i].crcydesc,
                    [`${this.$t('setuppersonpayrolldirectassignment.amount')}`]: item[i].netpay,
                    [`${this.$t('bankpaymentlistingreport.total')}`] : "",
                });
            }

                data.push ({
                    [`${this.$t('columns.no')}`]: "",
                    [`${this.$t('columns.name')}`]: "",
                    [`${this.$t('columns.staffid')}`]: "",
                    [`${this.$t('bankpaymentlistingreport.icnoorpassportno')}`]: "",
                    [`${this.$t('columns.company')}`]: "",
                    [`${this.$t('columns.department')}`]: "",
                    [`${this.$t('columns.currency')}`]: "",
                    [`${this.$t('setuppersonpayrolldirectassignment.amount')}`]: "",
                    [`${this.$t('bankpaymentlistingreport.total')}`] : this.total,

                });

            const csvData = this.objectToCSV(data)
            this.download(csvData)
        },
    },

    mounted() {   

    },

    created(){
        const vm = this;
        vm.formData = this.$route.params.formData;
        console.log("formdata received" , vm.formData)

        if(vm.formData.payoutcode){
            this.showID = true;
        } else {
            this.showDate = true;
        }
        
        this.loadStaff();
    }
    
}
</script>

<style>

.dateTitle {
    font-size: 12px;
    color:#FFFFFF;
    height: 0px;
    background-color: orange;
    align-content: center;
    justify-content: center;
}

.transparent{
    margin-bottom: 1px;
}


.export-icon-btns { display: flex; gap: 8px; align-items: center; }
.export-icon-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 6px 14px; border-radius: 8px; border: none;
  font-size: 0.8rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: all 0.15s;
}
.export-icon-pdf { background: #FEF2F2; color: #DC2626; border: 1px solid #FECACA; }
.export-icon-pdf:hover { background: #DC2626; color: #fff; border-color: #DC2626; }
.export-icon-csv { background: #ECFDF5; color: #059669; border: 1px solid #A7F3D0; }
.export-icon-csv:hover { background: #059669; color: #fff; border-color: #059669; }


/* ── Table horizontal scroll fix ── */
.rpt-table-wrap {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  border-radius: 8px 8px 0 0;
  border: 1px solid #E8EDF5;
}
.rpt-table-wrap .v-data-footer {
  position: sticky;
  left: 0;
  background: #fff;
  border-top: 1px solid #E8EDF5;
  min-width: unset !important;
}


/* ── Total bar ── */
.total-bar {
  width: 100%;
  background: linear-gradient(135deg, #4F6BFF 0%, #7C3AFF 100%);
  border-radius: 0 0 8px 8px;
  border: 1px solid #C7D2FE;
  border-top: none;
  padding: 12px 20px;
}
.total-bar-inner {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
}
.total-label {
  font-size: 0.88rem;
  font-weight: 700;
  color: rgba(255,255,255,0.85);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.total-amount {
  font-size: 1.1rem;
  font-weight: 800;
  color: #ffffff;
  background: rgba(255,255,255,0.15);
  padding: 4px 16px;
  border-radius: 20px;
  min-width: 120px;
  text-align: right;
  border: 1px solid rgba(255,255,255,0.25);
}
</style>